let product_video = document.querySelector('.product__video')

document.querySelectorAll('.ps-video').forEach(video => {

  video.addEventListener('elementinview', e => {

    let video_url = video.dataset.url || e.target.dataset.url

    // Vimeo | oEmbed API: https://developer.vimeo.com/api/oembed
    if (/vimeo.com/.test(video_url)) {
      let autoplay = `autoplay=${ video.dataset.autoplay == 'true' ? '1' : '0' }`
      let controls = 'controls=' + video.dataset.controls
      let muted = `muted=${ video.dataset.muted == 'true' ? '1' : '0' }`
      let loop = 'loop=' + video.dataset.loop
      fetch(`https://vimeo.com/api/oembed.json?url=${ video_url }?allow=autoplay&${ autoplay }&autopause=0&${ controls }&background=true&responsive=true&${ muted }&${ loop }`)
        .then(function (prom) {
          return prom.json()
        })
        .then(function(res) {
          video.insertAdjacentHTML('afterbegin', res.html)
          setTimeout(() => {
            video.querySelector('.site-loading').remove()
          }, 2000)
        })
        .catch(function (e) {
          console.log(e)
        })
    }

    // YouTube | iframe API: https://developers.google.com/youtube/iframe_api_reference
    if (/youtube.com/.test(video_url)) {
      if (product_video) {
        product_video.querySelector('.site-loading').style.display = 'flex'
      }
      let autoplay = video.dataset.autoplay == 'true' ? 1 : 0
      let controls = video.dataset.controls == 'true' ? 1 : 0
      let loop = video.dataset.loop == 'true' ? 1 : 0
      window.YT.ready(() => {
        let id = video_url.split('v=')[1]
        new YT.Player(video.id, {
          videoId   : id,
          playerVars: { 'autoplay': autoplay, 'controls': controls, 'loop': loop, 'playlist': id }
        })
        console.log(product_video.querySelector('.site-loading'))
        if (product_video) {
          setTimeout(() => {
            product_video.querySelector('.site-loading').style.display = 'none'
          }, 2000)
        }
      })
    }

  }, false)

})
